<script lang="ts" setup>
  import { MpSocialButton } from '@borg/ui';

  const emit = defineEmits<{
    (event: 'success'): void;
  }>();

  const config = useRuntimeConfig();
  const userStore = useUserStore();

  const isLoginInProgress = computed(
    () => userStore.loginState === 'inProgress' || userStore.initState === 'inProgress',
  );

  function onAppleLogin() {
    console.log('APPLE Login');
    try {
      AppleID.auth.signIn({
        clientId: config.public.appleClientId,
        redirectURI: window.location.origin,
        scope: 'name email',
        usePopup: true,
      });
    } catch (e: unknown) {
      console.error('error', e);
    }
  }

  async function handleAppleIDSignInOnSuccess(response: any) {
    console.log('success', response);
    emit('success');
  }

  async function handleAppleIDSignInOnFailure(response: any) {
    console.log('fail', response);
  }

  function initializeAppleApi() {
    try {
      console.log('APPLE Init');
      AppleID.auth.init({
        clientId: config.public.appleClientId,
        redirectURI: window.location.origin,
        scope: 'name email',
        usePopup: true,
      });

      document.addEventListener('AppleIDSignInOnSuccess', handleAppleIDSignInOnSuccess);
      document.addEventListener('AppleIDSignInOnFailure', handleAppleIDSignInOnFailure);
    } catch (e: unknown) {
      console.error('error', e);
    }
  }

  onMounted(() => {
    initializeAppleApi();
  });

  onUnmounted(() => {
    document.removeEventListener('AppleIDSignInOnSuccess', handleAppleIDSignInOnSuccess);
    document.removeEventListener('AppleIDSignInOnFailure', handleAppleIDSignInOnFailure);
  });
</script>

<template>
  <MpSocialButton
    brand="apple"
    :disabled="isLoginInProgress"
    @click="onAppleLogin"
  />
</template>
